import { LangTranslateService } from './lang-translate.service';

export function langSetupFactory(langSetupService: LangTranslateService) {
  return function() {
    return langSetupService.init();
  };
}
